import { BaseDto } from './base.dto';
import { CurrencyDto } from './currency.dto';
import { ProductDto } from './product.dto';
import { PriceBracketDto } from './priceBracket.dto';

export class RetailPriceDto extends BaseDto {
  productId: number;
  currencyId: number;
  currency?: CurrencyDto;
  product?: ProductDto;
  price: number;
  effectiveFrom: Date;
  GP?: number;
  priceBracketId?: number;
  priceBracket?: PriceBracketDto;
}
